function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Descriptions, Select, message, InputNumber, Tabs } from 'antd';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { Activity, EyeFill } from "react-bootstrap-icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var TabPane = Tabs.TabPane;

var EditConsultation = function EditConsultation(_ref) {
  var check = _ref.check,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formLoading = _useState2[0],
      setFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isPatientUpdated = _useState8[0],
      setIsPatientUpdated = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataLoading = _useState10[0],
      setIsDataLoading = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      bilanOptions = _useState12[0],
      setBilanOptions = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      serviceTree = _useState14[0],
      setServiceTree = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      medicalExamId = _useState16[0],
      setMedicalExamId = _useState16[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _Form$useForm3 = Form.useForm(),
      _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
      mcForm = _Form$useForm4[0];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setFormLoading(true);
    var formData = new FormData();
    formData.append("id", check.id);
    formData.append('weight', values.weight);
    formData.append('ta', values.ta);
    formData.append("ant_ophtalmo", values.ant_ophtalmo);
    formData.append("ant_medic", values.ant_ophtalmo);
    formData.append("ant_chirugie", values.ant_chirugie);
    formData.append("ant_allergy", values.ant_allergy);
    formData.append("ant_other", values.ant_other);
    formData.append("customer_id", check.customer.id);
    formData.append("uid", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editmedicalcheckintro', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setIsPatientUpdated(true);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  var onMcFinish = function onMcFinish(values) {
    setFormLoading(true);
    var formData = new FormData();
    formData.append("reason", values.reason);
    formData.append("traitement_anterieur", values.traitement_anterieur);
    formData.append("evolution", values.evolution);
    formData.append("avsc_d", values.avsc_d);
    formData.append("avc_d", values.avc_d);
    formData.append("annexes_d", values.annexes_d);
    formData.append("segment_d", values.segment_d);
    formData.append("cornee_d", values.cornee_d);
    formData.append("chambre_anterieure_d", values.chambre_anterieure_d);
    formData.append("pupille_d", values.pupille_d);
    formData.append("iris_d", values.iris_d);
    formData.append("reflexe_photomoteur_d", values.reflexe_photomoteur_d);
    formData.append("cristallin_d", values.cristallin_d);
    formData.append("fo_d", values.fo_d);
    formData.append("rio_d", values.rio_d);
    formData.append("dilatation_d", values.dilatation_d);
    formData.append("k1_d", values.k1_d);
    formData.append("k2_d", values.k2_d);
    formData.append("cylindre_d", values.cylindre_d);
    formData.append("axe_d", values.axe_d);
    formData.append("avsc_g", values.avsc_g);
    formData.append("avc_g", values.avc_g);
    formData.append("annexes_g", values.annexes_g);
    formData.append("segment_g", values.segment_g);
    formData.append("cornee_g", values.cornee_g);
    formData.append("chambre_anterieure_g", values.chambre_anterieure_g);
    formData.append("pupille_g", values.pupille_g);
    formData.append("iris_g", values.iris_g);
    formData.append("reflexe_photomoteur_g", values.reflexe_photomoteur_g);
    formData.append("cristallin_g", values.cristallin_g);
    formData.append("fo_g", values.fo_g);
    formData.append("rio_g", values.rio_g);
    formData.append("dilatation_g", values.dilatation_g);
    formData.append("k1_g", values.k1_g);
    formData.append("k2_g", values.k2_g);
    formData.append("cylindre_g", values.cylindre_g);
    formData.append("axe_g", values.axe_g);
    formData.append("diagnostic", values.diagnostic);
    formData.append("indication", values.indication);
    formData.append("conduite", values.conduite);
    formData.append("conclusion", values.conclusion);
    formData.append("uid", Common.currentUser.id);
    formData.append("id", check.id);
    formData.append("customer_id", check.customer.id);
    axios.post(Common.baseApiUrl + 'editmedicalcheckdetails', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setIsPatientUpdated(false);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      weight: check.customer.weight == "null" ? "" : check.customer.weight,
      ta: check.customer.ta == "null" ? "" : check.customer.ta,
      ant_allergy: check.customer.ant_allergy == "null" ? "" : check.customer.ant_allergy,
      ant_chirugie: check.customer.ant_chirugie == "null" ? "" : check.customer.ant_chirugie,
      ant_ophtalmo: check.customer.ant_ophtalmo == "null" ? "" : check.customer.ant_ophtalmo,
      ant_medic: check.customer.ant_medic == "null" ? "" : check.customer.ant_medic,
      ant_other: check.customer.ant_other == "null" ? "" : check.customer.ant_other
    });
    mcForm.setFieldsValue({
      reason: check.reason == "null" ? "" : check.reason,
      evolution: check.evolution == "null" ? "" : check.evolution,
      traitement_anterieur: check.traitement_anterieur == "null" ? "" : check.traitement_anterieur,
      avsc_d: check.avsc_d == "null" ? "" : check.avsc_d,
      avc_d: check.avc_d == "null" ? "" : check.avc_d,
      annexes_d: check.annexes_d == "null" ? "" : check.annexes_d,
      segment_d: check.segment_d == "null" ? "" : check.segment_d,
      cornee_d: check.cornee_d == "null" ? "" : check.cornee_d,
      chambre_anterieure_d: check.chambre_anterieure_d == "null" ? "" : check.chambre_anterieure_d,
      pupille_d: check.pupille_d == "null" ? "" : check.pupille_d,
      iris_d: check.iris_d == "null" ? "" : check.iris_d,
      reflexe_photomoteur_d: check.reflexe_photomoteur_d == "null" ? "" : check.reflexe_photomoteur_d,
      cristallin_d: check.cristallin_d == "null" ? "" : check.cristallin_d,
      rio_d: check.rio_d == "null" ? "" : check.rio_d,
      fo_d: check.fo_d == "null" ? "" : check.fo_d,
      dilatation_d: check.dilatation_d == "null" ? "" : check.dilatation_d,
      k1_d: check.k1_d == "null" ? "" : check.k1_d,
      k2_d: check.k2_d == "null" ? "" : check.k2_d,
      cylindre_d: check.cylindre_d == "null" ? "" : check.cylindre_d,
      axe_d: check.axe_d == "null" ? "" : check.axe_d,
      avsc_g: check.avsc_g == "null" ? "" : check.avsc_g,
      avc_g: check.avc_g == "null" ? "" : check.avc_g,
      annexes_g: check.annexes_g == "null" ? "" : check.annexes_g,
      segment_g: check.segment_g == "null" ? "" : check.segment_g,
      cornee_g: check.cornee_g == "null" ? "" : check.cornee_g,
      chambre_anterieure_g: check.chambre_anterieure_g == "null" ? "" : check.chambre_anterieure_g,
      pupille_g: check.pupille_g == "null" ? "" : check.pupille_g,
      iris_g: check.iris_g == "null" ? "" : check.iris_g,
      reflexe_photomoteur_g: check.reflexe_photomoteur_g == "null" ? "" : check.reflexe_photomoteur_g,
      cristallin_g: check.cristallin_g == "null" ? "" : check.cristallin_g,
      rio_g: check.rio_g == "null" ? "" : check.rio_g,
      dilatation_g: check.dilatation_g == "null" ? "" : check.dilatation_g,
      fo_g: check.fo_g == "null" ? "" : check.fo_g,
      k1_g: check.k1_g == "null" ? "" : check.k1_g,
      k2_g: check.k2_g == "null" ? "" : check.k2_g,
      cylindre_g: check.cylindre_g == "null" ? "" : check.cylindre_g,
      axe_g: check.axe_g == "null" ? "" : check.axe_g,
      diagnostic: check.diagnostic == "null" ? "" : check.diagnostic,
      indication: check.indication == "null" ? "" : check.indication,
      conduite: check.conduite == "null" ? "" : check.conduite,
      conclusion: check.conclusion == "null" ? "" : check.conclusion
    });
  }, [isPatientUpdated, check]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: check != null ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            children: /*#__PURE__*/_jsxs(Tabs, {
              animated: true,
              defaultActiveKey: 1,
              children: [/*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EyeFill, {
                    size: 30
                  }), "DONNEES"]
                }),
                children: /*#__PURE__*/_jsxs(Form, {
                  form: mcForm,
                  layout: "vertical",
                  onFinish: onMcFinish,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "reason",
                    label: "Motif",
                    rules: [{
                      required: true,
                      message: "Ce champ est obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(Input, {})
                  }), /*#__PURE__*/_jsx(Container, {
                    children: /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 6,
                        md: 6,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "evolution",
                          label: "Evolution",
                          children: /*#__PURE__*/_jsx(Input, {})
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 6,
                        md: 6,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "traitement_anterieur",
                          label: "Traitement anterieur",
                          children: /*#__PURE__*/_jsx(Input, {})
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "Oeil droit"
                    }), /*#__PURE__*/_jsxs(Container, {
                      children: [/*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "avsc_d",
                            label: "AVSC",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "avc_d",
                            label: "AVC",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "annexes_d",
                            label: "Annexes",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "segment_d",
                            label: "Segment ant\xE9rieur",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "cornee_d",
                            label: "Corn\xE9e",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "chambre_anterieure_d",
                            label: "Chambre ant\xE9rieure",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "pupille_d",
                            label: "Pupille",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "iris_d",
                            label: "Iris",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "reflexe_photomoteur_d",
                            label: "Reflexe photomoteur",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "cristallin_d",
                            label: "Cristallin",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "rio_d",
                            label: "PIO",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "dilatation_d",
                            label: "Dilatation",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "k1_d",
                            label: "K 1",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "k2_d",
                            label: "K 2",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "cylindre_d",
                            label: "Cylindre",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "axe_d",
                            label: "Axe",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 4,
                          md: 4,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "vitre_d",
                            label: "Vitr\xE9",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 4,
                          md: 4,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "fo_d",
                            label: "FO",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true,
                              size: "small"
                            })
                          })
                        })]
                      })]
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "Oeil gauche"
                    }), /*#__PURE__*/_jsxs(Container, {
                      children: [/*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "avsc_g",
                            label: "AVSC",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "avc_g",
                            label: "AVC",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "annexes_g",
                            label: "Annexes",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "segment_g",
                            label: "Segment ant\xE9rieur",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "cornee_g",
                            label: "Corn\xE9e",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "chambre_anterieure_g",
                            label: "Chambre ant\xE9rieure",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "pupille_g",
                            label: "Pupille",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "iris_g",
                            label: "Iris",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "k1_g",
                            label: "K 1",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "k2_g",
                            label: "K 2",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "cylindre_g",
                            label: "Cylindre",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "axe_g",
                            label: "Axe",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "reflexe_photomoteur_g",
                            label: "Reflexe photomoteur",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "cristallin_g",
                            label: "Cristallin",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "rio_g",
                            label: "RIO",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 3,
                          md: 3,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "dilatation_g",
                            label: "Dilatation",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 4,
                          md: 4,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "vitre_g",
                            label: "Vitr\xE9",
                            children: /*#__PURE__*/_jsx(Input, {
                              size: "small"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 4,
                          md: 4,
                          sm: 6,
                          xs: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            name: "fo_g",
                            label: "FO",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true,
                              size: "small"
                            })
                          })
                        })]
                      })]
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "Conclusion"
                    }), /*#__PURE__*/_jsx(Container, {
                      children: /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Diagnostic",
                            name: "diagnostic",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Indication",
                            name: "indication",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Conduite \xE0 suivre",
                            name: "conduite",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "CONCLUSION",
                            name: "conclusion",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        })]
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: formLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "SAUVEGARDER"
                      })
                    })
                  })]
                })
              }, 1), /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Activity, {
                    size: 30
                  }), "CONSTANTES"]
                }),
                children: /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  layout: "vertical",
                  onFinish: onFinish,
                  children: [/*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "CONSTANTES"
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "weight",
                      label: "Poids",
                      children: /*#__PURE__*/_jsx(InputNumber, {})
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ta",
                      label: "TA",
                      children: /*#__PURE__*/_jsx(Input, {})
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "ANTECEDANTS"
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_ophtalmo",
                      label: "Ophtalmologique",
                      children: /*#__PURE__*/_jsx(Input, {})
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_medic",
                      label: "Medicaux",
                      children: /*#__PURE__*/_jsx(Input, {})
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_chirugie",
                      label: "Chirugicaux",
                      children: /*#__PURE__*/_jsx(Input, {})
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_allergy",
                      label: "Allergie",
                      children: /*#__PURE__*/_jsx(Input, {})
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_other",
                      label: "Autres",
                      children: /*#__PURE__*/_jsx(Input, {})
                    })]
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: formLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "SAUVEGARDER"
                      })
                    })
                  }), errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
                    message: errorMessage,
                    type: "error",
                    banner: true
                  }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
                    message: successMessage,
                    type: "success",
                    banner: true
                  })]
                })
              }, 2)]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 5,
            md: 5,
            children: [/*#__PURE__*/_jsxs(Descriptions, {
              labelStyle: {
                background: '#FCD013'
              },
              contentStyle: {
                background: '#FCD013'
              },
              column: 1,
              bordered: true,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Nom",
                children: check.customer.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Pr\xE9nom",
                children: check.customer.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Profession",
                children: check.customer.job
              })]
            }), /*#__PURE__*/_jsx("br", {})]
          })]
        })
      })
    }) : /*#__PURE__*/_jsx("p", {
      children: "Une erreur est survenue"
    })
  });
};

export default EditConsultation;